export default {"src":"/_next/static/media/claude.58786435.svg","height":40,"width":40};